<!-- 
Dialog for uploading the invoice template.
-->
<template>
  <v-dialog :value="show" persistent content-class="dialog sm">
    <v-card>
      <v-toolbar color="secondary" flat dark>
        <v-toolbar-title>
          Upload {{ description }}
        </v-toolbar-title>
        <v-spacer/>
      </v-toolbar>
      <our-busy-indicator :show="state.loading"/>
      <v-card-text>
        <v-form ref="form" enctype="multipart/form-data" novalidate>
          <div :class="state.loading ? '' : 'dropbox-active'" class="dropbox">
            <input 
              v-if="!state.loading"
              type="file"
              class="input-file"
              @change="filesChange($event.target.files)"
            >
            <p v-if="!state.loading" class="subheading ml-4 mr-4">
              Drag the template file here to begin<br>or click to browse.
            </p>
            <p v-else>
              Uploading the template, please wait...
            </p>
          </div>
        </v-form>
      </v-card-text>
      <v-card-actions class="justify-right">
        <v-btn :disabled="state.loading" flat @click="hide">Close</v-btn>
      </v-card-actions>
    </v-card>
    <our-validation-dialog v-model="showValidationDialog" :form="this.$refs.form" :state-error="state.error"/>
  </v-dialog>
</template>

<script>
import { INVOICE_TEMPLATE_UPLOAD } from "@/store/levy-collections/action-types";

export default {
  model: {
    prop: "show",
    event: "update:show"
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    },
    levyCollectionId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      uploadedFiles: [],
      showFileTypeWarning: false,
      formData: null,
      showValidationDialog: false
    };
  },
  computed: {
    state() {
      return this.$store.state.levyCollections.pdfTemplate;
    }
  },
  watch: {
    show() {
      this.reset();
    }
  },
  methods: {
    hide() {
      this.$emit("update:show", false);
    },
    reset() {
      this.uploadedFiles = [];
      this.formData = null;
      this.showFileTypeWarning = false;
    },
    async save() {
      if (this.$refs.form.validate() && (await this.$store.dispatch(INVOICE_TEMPLATE_UPLOAD, {
        levyCollectionId: this.levyCollectionId,
        type: this.type,
        formData: this.formData
      }))) {
        this.hide();
      } else {
        this.showValidationDialog = true;
      }
    },
    filesChange(fileList) {
      if (fileList.length) {
        const filename = fileList[0].name;
        if (filename) {
          this.formData = new FormData();
          this.formData.append("document", fileList[0]);
          this.save();
        }
      }
    }
  }
};
</script>

<style lang="scss">
.dropbox-active {
  outline: 2px dashed grey; /* the dash box */
  .input-file {
    cursor: pointer;
  }
}

.dropbox-active:hover {
  background: lightgray; /* when mouse over to the drop zone, change color */
}

.dropbox {
  outline-offset: -10px;
  color: dimgray;
  padding: 10px 10px;
  min-height: 300px; /* minimum height */
  position: relative;
  cursor: pointer;
}

.input-file {
  opacity: 0; /* invisible but it's there! */
  width: 100%;
  height: 300px;
  position: absolute;
}

.dropbox p {
  font-size: 1.2em;
  text-align: center;
  padding: 50px 0;
}
</style>